module.exports = "././fonts/fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 1134
// module chunks = 0